<ng-container *transloco="let t">
  <div class="certificate-form">
    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Date of sterilization') }}</mat-label>
      <input
        matInput
        [matDatepicker]="pickerDateOfSterilization"
        [formControl]="dateOfSterilization"
        [min]="minDate"
        [max]="today"
      />
      <mat-datepicker-toggle
        matIconSuffix
        [for]="pickerDateOfSterilization"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerDateOfSterilization></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('protocolNumber') }}</mat-label>
      <input matInput [formControl]="protocolNumber" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('Note') }}</mat-label>
      <textarea matInput rows="4" [formControl]="note"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput [formControl]="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
